<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.sdv plans") }}</h2>
        </div>
     
    </div>

    <div class="wrapper wrapper-content">
        <div class="ibox-content mb-1 px-3 py-2">
            <div class="form-group mb-1">
                <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
                    <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                        <label class="mb-0">{{ $t("navigations.plan name") }}</label>
                        <input type="text" v-model="searchData.PlanName" class="form-control my-md-2 my-lg-0" />
                    </div>
                    <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                        <label class="mb-0">{{ $t("navigations.effective from") }}</label>
                        <input type="date" v-model="searchData.EffectiveFrom" class="form-control my-md-2 my-lg-0" />
                    </div>
                    <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                        <label class="mb-0">{{ $t("navigations.status") }}</label>
                        <select class="form-select my-md-2 my-lg-0" v-model="searchData.Status">
                            <option value="">{{ $t("navigations.all") }}</option>
                            <option value="Draft">{{ $t("navigations.draft") }}</option>
                            <option value="Active">{{ $t("navigations.active") }}</option>
                            <option value="Superseded">{{ $t("navigations.superseded") }}</option>
                            <option value="Retired">{{ $t("navigations.retired") }}</option>
                        </select>
                    </div>
                    <span @click.prevent="search()"
                        class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end">
                        {{ $t("navigations.search") }}
                    </span>
                </div>
            </div>
        </div>

        <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between">
                <h5 class="mt-1">{{ $t("navigations.sdv plan list") }}</h5>
                   <div class="col-lg-2 text-end d-flex justify-content-end">
            <div class="position-relative align-self-center mr-3"
                v-if="!roleprivileges || roleprivileges.includes('SDV Plan Create')" aria-label="Create new SDV plan"
                tabindex="0">
                <img width="17" height="17" class="cursor-pointer" src="../../assets/img/create.png" alt="New Plan"
                    @click.prevent="openCreateModal()" />
                <div class="tool-tip">{{ "Create Plan" }}</div>
            </div>
        </div>
            </div>
            <div class="ibox-content">
                <template v-if="showTableLoading === true">
                    <div class="text-center">
                        <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
                        <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
                    </div>
                </template>

                <template v-else>
                    <div class="text-center" v-if="planList.entities.length === 0">
                        <p>{{ $t("navigations.no data available") }}</p>
                    </div>

                    <div v-else class="table-responsive">
                        <table class="table table-striped table-bordered dataTables">
                            <thead>
                                <tr>
                                    <th class="sort_block" @click="SortSelected('PlanVersion')">
                                        <div class="d-flex flex-row justify-content-between">
                                            {{ $t("navigations.version") }}
                                            <span>
                                                <i class="fa fa-long-arrow-up"
                                                    :class="{ 'text-primary': searchData.SortBy === 'PlanVersion' && searchData.SortOrder === 'asc' }"></i>
                                                <i class="fa fa-long-arrow-down"
                                                    :class="{ 'text-primary': searchData.SortBy === 'PlanVersion' && searchData.SortOrder === 'desc' }"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th class="sort_block" @click="SortSelected('PlanName')">
                                        <div class="d-flex flex-row justify-content-between">
                                            {{ $t("navigations.plan name") }}
                                            <span>
                                                <i class="fa fa-long-arrow-up"
                                                    :class="{ 'text-primary': searchData.SortBy === 'PlanName' && searchData.SortOrder === 'asc' }"></i>
                                                <i class="fa fa-long-arrow-down"
                                                    :class="{ 'text-primary': searchData.SortBy === 'PlanName' && searchData.SortOrder === 'desc' }"></i>
                                            </span>
                                        </div>
                                    </th>
                                 
                                    <th>{{ $t("navigations.study version") }}</th>
                                    <th>{{ $t("navigations.status") }}</th>
                                    <th class="sort_block" @click="SortSelected('EffectiveFrom')">
                                        <div class="d-flex flex-row justify-content-between">
                                            {{ $t("navigations.effective from") }}
                                            <span>
                                                <i class="fa fa-long-arrow-up"
                                                    :class="{ 'text-primary': searchData.SortBy === 'EffectiveFrom' && searchData.SortOrder === 'asc' }"></i>
                                                <i class="fa fa-long-arrow-down"
                                                    :class="{ 'text-primary': searchData.SortBy === 'EffectiveFrom' && searchData.SortOrder === 'desc' }"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th>{{ $t("navigations.rule count") }}</th>
                                      <th class="text-center">{{ $t("navigations.rules") }}</th>
                                    <th class="text-center"
                                        v-if="!roleprivileges || roleprivileges.includes('SDV Plan Edit')">
                                        {{ $t("navigations.edit") }}
                                    </th>
                                    <th class="text-center">{{ $t("navigations.actions") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(plan, index) in planList.entities" :key="plan.id">
                                    <td>{{ plan.planVersion }}</td>
                                    <td>{{ plan.planName }}</td>
                                    
                                    <td>{{ plan.studyVersion }}</td>
                                    <td>{{ plan.status }}</td>
                                    <td>{{ filter(plan.effectiveFrom) }}</td>
                                    <td>{{ plan.ruleCount }}</td>
                                    <td class="text-center">
                                        <i class="fa fa-eye edit-delete" data-v-72fff5cd="" 
                                         v-if="!roleprivileges || roleprivileges.includes('SDV Plan View Rules')"
                                          @click="viewRules(plan)"></i>
                                    </td>
                                    <td class="text-center"
                                        v-if="!roleprivileges || roleprivileges.includes('SDV Plan Edit')">
                                        <i class="fa fa-edit edit-delete"
                                            :class="{ 'disabled-icon': plan.status !== 'Draft' }"
                                            style="color: rgb(161, 59, 124);"
                                            @click="plan.status === 'Draft' && editPlan(plan.id)"></i>
                                    </td>

                                    <td class="text-center" v-on:clickout="showSidePopup[index] = false">
                                        <div class="position-relative cursor-pointer"
                                            @click.prevent="showSidePopup[index] = !showSidePopup[index]">
                                            <i class="fa fa-ellipsis-v"></i>
                                        </div>
                                        <div class="plan-side-popup-form" v-if="showSidePopup[index]">
                                            
                                           <div v-if="plan.status === 'Draft' && (!roleprivileges || roleprivileges.includes('SDV Plan Approve'))"
                                                @click.prevent="openApproveModal(plan); showSidePopup[index] = false">
                                                Approve & Activate
                                            </div>
                                            <div v-if="plan.status === 'Active' && (!roleprivileges || roleprivileges.includes('SDV Plan Retire'))"
                                                @click.prevent="openRetireModal(plan); showSidePopup[index] = false">
                                                {{ $t("navigations.retire plan") }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="planList.entities.length != 0" class="row mt-1 mx-0">
                        <div class="col-lg-12 mx-0 px-0">
                            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                                    <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1"
                                        active-color="#618bd7" @update:modelValue="loadPage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <SdvPlanModal v-if="showPlanModal" :editingId="editingPlanId" @closeModal="closePlanModal"
        @saved="refreshPlanList" />
        <ManageSDVRuleList
  v-if="showRulesListModal"
  :planId="rulesPlanId"
  :planVersion="rulesPlanVersion"
  :planStatus="rulesPlanStatus"
  @closeModal="closeRulesList"
/>

        <GenericApproveRejectModal
    v-if="showApproveRetireModal"
    :heading="approveRetireContext.heading"
    :action1Label="approveRetireContext.action1Label"
    action2Label="Cancel"
    :action2IsCancel="true"
    :apiUrl="`${baseurl}/management/sdv/approveretiresdvplan`"
    :payload="approveRetireContext.payload"
    commentsKey="retireReason"
    statusKey="type"
    :statusValueApprove="approveRetireContext.type"
    :successMsgApprove="approveRetireContext.successMsg"
    fromPage="sdvPlan"
    @closePopup="closeApproveRetireModal"
    @actionSuccess="onApproveRetireSuccess"
    @actionError="onApproveRetireError"
/>
</template>

<script src="./Sdvplan.js"></script>

<style scoped>
.badge-draft {
    background-color: #6c757d;
    color: #fff;
    padding: 3px 8px;
    border-radius: 4px;
}

.badge-active {
    background-color: #28a745;
    color: #fff;
    padding: 3px 8px;
    border-radius: 4px;
}

.badge-superseded {
    background-color: #ffc107;
    color: #212529;
    padding: 3px 8px;
    border-radius: 4px;
}

.badge-retired {
    background-color: #dc3545;
    color: #fff;
    padding: 3px 8px;
    border-radius: 4px;
}

.action-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 10px;
    z-index: 1000;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 150px;
    text-align: left;
}

.dropdown-item {
    display: block;
    padding: 6px 12px;
    font-size: 0.85rem;
    color: #333;
    cursor: pointer;
}

.dropdown-item:hover {
    background-color: #f1f1f1;
}

.disabled-icon {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
}

.plan-side-popup-form {
    position: absolute;
    text-align: left;
    right: 115px;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    width: min(133px, 90%);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
}

.plan-side-popup-form>div {
    cursor: pointer;
    padding: 0.5rem;
}

.plan-side-popup-form>div:hover {
    background-color: #e4eaf9;
}

.disabled-icon {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
}
.position-relative .tool-tip {
    right: 18px !important;
    top: 0px !important;
}
</style>